import { useRef, useState } from "react";
import type { ParsedVoiceMealDraft } from "../../application/remote-meal-parser";

export function useMealRecognition(onComplete: (draft: ParsedVoiceMealDraft) => void) {
  const [items, setItems] = useState<string[] | null>(null);
  const pending = useRef<ParsedVoiceMealDraft | null>(null);
  const callback = useRef(onComplete);
  callback.current = onComplete;
  const begin = () => { pending.current = null; setItems([]); };
  const show = (draft: ParsedVoiceMealDraft) => {
    pending.current = draft;
    const rows = draft.nutrition?.rows ?? [];
    const names = rows.length ? rows.map(row => row.portion ? `${row.name} · ${row.portion}` : row.name) : draft.items.map(item => item.name);
    setItems(names.length ? names : ["Данные обработаны"]);
  };
  const cancel = () => { pending.current = null; setItems(null); };
  const complete = () => {
    const draft = pending.current;
    cancel();
    if (draft) callback.current(draft);
  };
  return { items, begin, show, cancel, complete };
}
